import React from 'react';
import Icon from './Icon';

export default function Button({
  children,
  className = '',
  icon,
  selected = false,
  variant = 'secondary',
  ...props
}) {
  const classes = [
    'pl-button',
    `pl-button--${variant}`,
    selected ? 'pl-button--selected' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={classes} type="button" {...props}>
      {icon ? <Icon name={icon} size={22} /> : null}
      {children}
    </button>
  );
}
